import axios from "axios";

const remoteApi = axios.create();

const setToken = (token) => {
	remoteApi.defaults.headers.common.API_TOKEN = token;
};

const setJwt = (jwt, logout) => {
	remoteApi.defaults.headers.common.Authorization = `Bearer ${jwt}`;

	if (remoteApi.interceptors.response.length > 0) {
		return;
	}

	remoteApi.interceptors.response.use((response) => {
		if (response && response.status === 401) {
			logout();
		}

		return response;
	}, (error) => {
		if (error && error.response && error.response.status === 401) {
			logout();
			return Promise.resolve();
		}

		return Promise.reject(error);
	});
};

const setBase = (url) => {
	remoteApi.defaults.baseURL = url;
};

const login = r => remoteApi.post("/api/login", r);
const analyze = r => remoteApi.post("/api/analysis", r);
const status = id => remoteApi.get(`/api/analysis/status?id=${id}`);
const holterReport = r => remoteApi.post("/api/analysis/generate-holter-report", r);
const serverStatus = () => remoteApi.get("/api/server-status");
const validateToken = () => remoteApi.get("/api/server-status/validate-api-token");
const validateJwt = token => remoteApi.post("/api/validatetoken", { token });
const existingPartners = () => remoteApi.get("/api/partner");
const generateInviteLinkForPartner = id => remoteApi.post("/api/invite", { partnerId: id });
const addPartner = (partnerName, partnerDescription) => remoteApi.post("/api/partner", { name: partnerName, description: partnerDescription });
const deletePartner = partnerId => remoteApi.delete("/api/partner", { data: { partnerId } });
const getApplication = id => remoteApi.get(`/api/application/${id}`);
const existingApplications = id => remoteApi.get(`/api/application/partner/${id}`);
const addApplication = r => remoteApi.post("/api/application", r);
const deleteApplication = id => remoteApi.delete("/api/application", { data: { id } });
const generateNewAppToken = id => remoteApi.post("/api/application/new-token", { id });
const updateApplicationConfig = r => remoteApi.patch("/api/application", r);
const register = r => remoteApi.post("/api/register", r);
const confirm = token => remoteApi.post("/api/register/confirm", { token });
const forgotPassword = username => remoteApi.post("/api/resetpassword", { username });
const resetPassword = r => remoteApi.post("/api/resetpassword/reset", r);

export default {
	login,
	analyze,
	status,
	holterReport,
	serverStatus,
	setToken,
	validateToken,
	setBase,
	setJwt,
	validateJwt,
	existingPartners,
	generateInviteLinkForPartner,
	addPartner,
	deletePartner,
	getApplication,
	existingApplications,
	addApplication,
	deleteApplication,
	generateNewAppToken,
	updateApplicationConfig,
	register,
	confirm,
	forgotPassword,
	resetPassword,
};
